import { omit } from 'lodash-es';
import { INVENTORY_TYPES_LOWERCASE } from 'client/constants/inventory-types';
import { NEW_MAKE_MODEL_URL_PATTERN } from 'site-modules/shared/constants/inventory/srp-url-patterns';
import { venomHistory } from 'client/utils/history/venom-history';
import { getSrpBrowserQuery } from 'site-modules/shared/utils/inventory/srp-utils';

export const CORE_SRP_INVENTORY_COUNT = { true: 3, false: 2 };
export const CONSTANT_FILTERS = ['make', 'model', 'initialUrlPattern', 'pageSize'];

export function getInitialSearchFilter({ makeSlug, modelSlug, year, inventoryType, initialUrlPattern, sortBy }) {
  const filter = {
    make: [makeSlug],
    model: [`${makeSlug}|${modelSlug}`],
  };

  if (year) {
    filter.year = `${year}`;
  }

  if (inventoryType) {
    filter.inventoryType = [inventoryType];
  }

  if (initialUrlPattern) {
    filter.initialUrlPattern = initialUrlPattern;
  }

  if (sortBy) {
    filter.sortBy = sortBy;
  }

  return filter;
}

export function getPreprodInitialSearchFilter(params) {
  return getInitialSearchFilter({
    ...params,
    inventoryType: INVENTORY_TYPES_LOWERCASE.NEW,
    initialUrlPattern: NEW_MAKE_MODEL_URL_PATTERN,
  });
}

export function getUnknownLocationSearchFilter(isInternational) {
  return isInternational ? { national: true } : {};
}

export function addFiltersToQuery(pathname, filter) {
  const query = getSrpBrowserQuery(omit(filter, CONSTANT_FILTERS));

  venomHistory.push(`${pathname}${query ? `?${query}` : ''}`);
}
